import HttpClient from '@/rahmen/httpClient'
import controls from '@/rahmen/controls'
import effects from '@/rahmen/utils/effects'
import Logger from '@/rahmen/logger'
import ClientDB from '@/rahmen/clientDB'
import { ArrayFilter } from '@/rahmen/arrayFilter'
import complement from '@/rahmen/complement'
import validator from '@/rahmen/validators'
import conf from '@/rahmen/conf'
// import messages from '@/ddv2.library/messages'
import modals from '@/ddv2.library/modals'
import { mapGetters } from 'vuex'

import store from '@/store'

/**
 * @file 編集画面用Mixin
 * @namespace mixins
 */
/**
 * @module viewMixins
 */
/**
 * @vue-data {Logger} [Logger=new Logger()] - ログ出力クラス
 * @vue-data {controls} [Ctrls=controls] - コントロール定義
 * @vue-data {HttpClient} [HttpClient=new HttpClient()] - http通信用クラス
 * @vue-data {effects} [Effects=effects] - ローディングエフェクト
 * @vue-data {ArrayFilter} [Filters=new ArrayFilter([])] - 配列フィルタクラス
 * @vue-data {complement} [Complement=complement] - フォーマット補完モジュール
 * @vue-data {validator} [Validators=validator] - 検証モジュール
 * @vue-computed {Array} msysGamenSeni - DDMasters/msysGamenSeni
 * @vue-computed {Number} currentKinoId - system/currentKinoId
 * @vue-computed {String} currentKaishaCode - users/currentKaishaCode
 * @see rahmen.controls
 * @see rahmen.arrayFilter
 * @see rahmen.httpClient
 * @see rahmen.utils.effects
 * @see rahmen.logger
 * @see rahmen.arrayFilter
 * @see rahmen.complement
 * @see rahmen.validators
 */
export default {
  data: () => ({
    Logger: new Logger(),
    Ctrls: controls,
    HttpClient: new HttpClient(),
    Effects: effects,
    Filters: new ArrayFilter([]),
    Complement: complement,
    Validators: validator
  }),
  computed: {
    ...mapGetters({
      msysGamenSeni: 'DDMasters/msysGamenSeni',
      currentKinoId: 'system/currentKinoId',
      currentKaishaCode: 'users/currentKaishaCode'
    })
  },
  methods: {
    /**
     * 画面スクロール可否設定を行う
     * @param {Boolean} enableScroll スクロール可否
     */
    setEnableViewScroll (enableScroll) {
      const elem = document.getElementsByTagName('html')[0]
      console.log('setEnableViewScroll', elem.style, enableScroll)
      elem.style.overflowY = enableScroll ? 'scroll' : 'hidden'
    },
    transition (actionId, param, callback) {
      const params = param || {}
      const kinoId = this.currentKinoId
      const kaishaCode = this.currentKaishaCode
      const urlList = this.msysGamenSeni
      const self = this
      console.log('transition', { kaishaCode, kinoId, actionId, params })

      let trans = urlList.find((m) => {
        return m.kaishaCd === kaishaCode &&
          m.mstKinoId === kinoId &&
          m.actionNo === actionId
      })

      if (trans === undefined) {
        const transXX = urlList.find((m) => {
          return m.kaishaCd === '****' &&
            m.mstKinoId === kinoId &&
            m.actionNo === actionId
        })
        if (transXX === undefined) {
          console.error('遷移先の値が存在しません。', { urlList, kaishaCode, kinoId, actionId })
        } else {
          trans = transXX
        }
      }

      const viewname = trans.senisakiViewNm
      console.log(viewname)
      console.log('transition', this.$router)

      const currentRoute = this.$router.currentRoute
      const currentParam = JSON.stringify(currentRoute.params, (key, value) => {
        // 数値の場合は文字列に変換する
        return typeof value === 'number' ? value.toString() : value
      })
      const transParam = JSON.stringify(param, (key, value) => {
        // 数値の場合は文字列に変換する
        return typeof value === 'number' ? value.toString() : value
      })
      if (currentRoute.name === viewname && currentParam === transParam) {
        callback()
        return
      }

      self.clearSummaryMessage()
      console.log('XXX', { name: viewname, params: param })
      if (currentRoute.name.includes('-list')) {
        const cache = {
          rows: self.rows,
          conditions: self.conditions,
          searchText: self.searchText,
          page: self.page,
          itemsPerPage: self.itemsPerPage
        }
        self.saveToChache(cache)
          .then(() => {
          })
      }
      self.$router.push({ name: viewname, params: param }).catch((e) => {
        console.log('exception', e)
        self.Effects.loadComplete()
      })
    },
    saveToChache (data) {
      const id = this.currentKinoId
      console.log('viewMixins.saveToChache', id, data)
      return new Promise((resolve, reject) => {
        const db = new ClientDB(conf.cacheStoreName)
        db.register(id, data)
          .then((d) => {
            console.log('viewMixins.saveToChache', id, data, d)
            resolve(d)
          })
          .catch((e) => {
            reject(e)
          })
      })
    },
    saveToChacheById (id, data) {
      console.log('viewMixins.saveToChacheById', id, data)
      return new Promise((resolve, reject) => {
        const db = new ClientDB(conf.cacheStoreName)
        db.register(id, data)
          .then((d) => {
            console.log('viewMixins.saveToChacheById', id, data, d)
            resolve(d)
          })
          .catch((e) => {
            reject(e)
          })
      })
    },
    loadFromCache () {
      const id = this.currentKinoId
      console.log('viewMixins.loadFromCache', id)
      return new Promise((resolve, reject) => {
        const db = new ClientDB(conf.cacheStoreName)
        db.get(id)
          .then((data) => {
            console.log('viewMixins.loadFromCache', id, data)
            resolve(data)
          })
          .catch((e) => {
            reject(e)
          })
      })
    },
    loadFromCacheById (id) {
      console.log('viewMixins.loadFromCacheById', id)
      return new Promise((resolve, reject) => {
        const db = new ClientDB(conf.cacheStoreName)
        db.get(id)
          .then((data) => {
            console.log('viewMixins.loadFromCacheById', id, data)
            resolve(data)
          })
          .catch((e) => {
            reject(e)
          })
      })
    },
    loadLoginInfo () {
      return new Promise((resolve) => {
        store.dispatch('users/loadLoginInfo')
          .then(() => {
            resolve()
          })
          .catch((e) => {
            console.error(e)
          })
      })
    },
    filtering (value, search, item) {
      return this.Filters.filter(value, search, item)
    },
    setSummaryMessage (message) {
      // store.dispatch('system/setMessage', { message })
      modals.showToast(message, null, 450, null, null)
    },
    clearSummaryMessage () {
      store.dispatch('system/clearMessage')
    },
    setInvalidSummaryMessage (messageCd) {
      // const message = messages.getInfo(messageCd)
      // store.dispatch('system/setMessage', { message })
      modals.showToastMessage(messageCd, null, 450, null, null)
    },
    kubunListFilter (kubunList, kbnShuruiCd) {
      return kubunList.filter((elem) => {
        return elem.kbnShuruiCd === kbnShuruiCd && elem.kaishaCd === this.currentKaishaCode
      })
    },
    kubunListFilterForDropDownItem (kubunList, kbnShuruiCd) {
      const l = this.kubunListFilter(kubunList, kbnShuruiCd)
      var defArray = [{ value: null, text: '未選択' }]
      const resultArray = l.map(elem => {
        return {
          value: elem.code,
          text: `${elem.code}:${elem.codeNm}`
        }
      })
      return defArray.concat(resultArray)
    },
    kubunListFilterForSpreadSheetDropDownItem (kubunList, kbnShuruiCd) {
      const l = this.kubunListFilter(kubunList, kbnShuruiCd)
      var defArray = ['未選択']
      const resultArray = l.map(elem => {
        return elem.codeNm
      })
      return defArray.concat(resultArray)
    },
    sbtListFilter (sbtList, sbtShuruiCd) {
      return sbtList.filter((elem) => {
        return elem.sbtShuruiCd === sbtShuruiCd && elem.kaishaCd === this.currentKaishaCode
      })
    },
    sbtListFilterForDropDownItem (sbtList, sbtShuruiCd) {
      const l = this.sbtListFilter(sbtList, sbtShuruiCd)
      var defArray = [{ value: null, text: '未選択' }]
      const resultArray = l.map(elem => {
        return {
          value: elem.sbtCd,
          text: `${elem.sbtCd}:${elem.sbtNm}`
        }
      })
      return defArray.concat(resultArray)
    },
    sbtListFilterForSpreadSheetDropDownItem (sbtList, sbtShuruiCd) {
      const l = this.sbtListFilter(sbtList, sbtShuruiCd)
      var defArray = [{ id: null, name: '未選択' }]
      const resultArray = l.map(elem => {
        return {
          id: elem.sbtNm,
          name: elem.sbtNm
        }
      })
      return defArray.concat(resultArray)
    },
    validateAll (refs) {
      let result
      const ctrls = Object.keys(refs)
      ctrls.forEach(c => {
        let targets = []
        if (Array.isArray(refs[c])) {
          targets = targets.concat(refs[c])
        } else {
          targets.push(refs[c])
        }
        targets.forEach(t => {
          if (t === undefined) { return }
          if (t[controls.VALIDATE_METHOD] === undefined) { return }
          if (t[controls.GET_INVALID_METHOD] === undefined) { return }
          t[controls.VALIDATE_METHOD]()
          const res = t[controls.GET_INVALID_METHOD]()
          if (res === undefined) { return }
          result = res
        })
      })
      console.log('validateAll', result)
      return result === undefined
    },
    /**
     * Mixin用 個別検証処理
     */
    validate () {
      return true
    },
    setInvalidMessage (refs, invalidList) {
      const invalids = invalidList || {}
      const list = Object.keys(invalids)
      list.forEach(l => {
        // console.log('setInvalidMessage', l, list[l], refs[l][controls.SET_INVALID_METHOD])
        if (refs[l] === undefined || refs[l][controls.SET_INVALID_METHOD] === undefined) { return }
        refs[l][controls.SET_INVALID_METHOD](invalids[l])
      })
    },
    clearInvalidMessage (refs) {
      const ctrls = Object.keys(refs)
      console.log('clearInvalidMessage', refs)
      ctrls.forEach(c => {
        let targets = []
        if (Array.isArray(refs[c])) {
          targets = targets.concat(refs[c])
        } else {
          targets.push(refs[c])
        }
        targets.forEach(t => {
          if (t !== undefined) {
            if (t[controls.CLEAR_INVALID_METHOD] === undefined) {
              t.invalidMessage = undefined
              return
            }
            t[controls.CLEAR_INVALID_METHOD]()
          }
        })
      })
    },
    clearScrollStatus (selector) {
      const elem = document.querySelector(selector)
      console.log('clearScrollStatus', elem)
      if (elem) {
        elem.scrollTo(0, 999)
        elem.scrollTop = 0
      }
    },
    clearScrollStatusForDialog () {
      this.clearScrollStatus('.v-dialog.v-dialog--active')
    },
    controlScrollPosition (selector, pos) {
      const elem = document.querySelector(selector)
      console.log('clearScrollStatus', elem)
      if (elem) {
        elem.scrollIntoView(true)
        scrollTo(0, elem.getBoundingClientRect().top + window.pageYOffset - pos)
      }
    }
  }
}
